import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"

const cursorsSnippet = `
    this.cursors = this.input.keyboard.createCursorKeys();
`

const inputSnippet = `
    // Check player input
    if (this.cursors.left.isDown) {
      this.player.setVelocityX(-160);
    } else if (this.cursors.right.isDown) {
      this.player.setVelocityX(160);
    } else if (this.cursors.up.isDown) {
      this.player.setVelocityY(-160);
    } else if (this.cursors.down.isDown) {
      this.player.setVelocityY(160);
    } else {
      this.player.setVelocityX(0);
      this.player.setVelocityY(0);
    }
`

const PlayerInput = () => (
  <>
    <h1>Player Input</h1>
    <p>
      Now that we have a plane showing up we need to be able to move it around.
      To do this we need to capture input from the players keyboard.
    </p>
    <p>
      The first thing we need to do is add a new variable called cursors. You
      can type it in or copy it from the snippet below and add it at the end of
      our variables list.
    </p>
    <a href="https://docs.phaser.io/api-documentation/class/input-keyboard-keyboardplugin#createcursorkeys">
      Cursor Keys Documentation
    </a>
    <br />
    <a href="https://phaser.io/examples/v3.85.0/input/keyboard/view/cursor-keys">
      Code Example
    </a>
    <br />
    <a href="https://docs.phaser.io/api-documentation/class/physics-arcade-sprite#setvelocityx">
      Velocity Documentation
    </a>
    <CopyBlock
      text={`cursors;`}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Next we need to tell Phaser what our cursors variable is. Inside the
      create method add the following snippet:
    </p>
    <CopyBlock
      text={cursorsSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>Add this code snippet into the update function: </p>
    <CopyBlock
      text={inputSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <br />

    <Button type="button" variant="secondary" href="/PlayerProjectiles">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default PlayerInput
